import { render, staticRenderFns } from "./ProjectDetailsView.vue?vue&type=template&id=51658391&scoped=true&"
import script from "./ProjectDetailsView.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsView.vue?vue&type=style&index=0&id=51658391&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51658391",
  null
  
)

export default component.exports